var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CryptoJS from 'crypto-js';
import { injectable } from 'inversify';
import { ApiClient } from './base-axios-client';
var EncryptionApiClient = /** @class */ (function (_super) {
    __extends(EncryptionApiClient, _super);
    function EncryptionApiClient() {
        return _super.call(this, '/api/v1/management/encryption') || this;
    }
    EncryptionApiClient = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], EncryptionApiClient);
    return EncryptionApiClient;
}(ApiClient));
var EncryptionService = /** @class */ (function () {
    function EncryptionService() {
    }
    /**
     * Encrypts a user ID using AES-256 CBC before sending to the backend.
     * Key material is fetched from the aggregator, which requires a bearer token.
     */
    EncryptionService.encryptUserId = function (userId) {
        return __awaiter(this, void 0, Promise, function () {
            var material, key, iv, encrypted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userId) {
                            throw new Error('User ID cannot be empty');
                        }
                        return [4 /*yield*/, this.getKey()];
                    case 1:
                        material = _a.sent();
                        key = CryptoJS.enc.Base64.parse(material.key);
                        iv = CryptoJS.enc.Base64.parse(material.iv);
                        encrypted = CryptoJS.AES.encrypt(userId, key, {
                            iv: iv,
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7,
                        });
                        return [2 /*return*/, encrypted.toString()]; // Base64 encoded ciphertext
                }
            });
        });
    };
    EncryptionService.getKey = function () {
        var _this = this;
        var cached = this.keyPromise;
        if (cached) {
            return cached;
        }
        // Constructed per call so the current access token is picked up.
        var pending = new EncryptionApiClient()
            .get('/key')
            .then(function (response) {
            var data = response.data || {};
            // Case-insensitive: the aggregator's camelCase strategy renames AES_KEY to aeS_KEY.
            var read = function (name) {
                var match = Object.keys(data).find(function (k) {
                    var lower = k.toLowerCase();
                    return lower === name || lower === "aes_" + name;
                });
                return match ? data[match] : '';
            };
            var key = read('key');
            var iv = read('iv');
            if (!key || !iv) {
                throw new Error("Encryption key and IV were not returned - got " + JSON.stringify(response.data));
            }
            return { key: key, iv: iv };
        })
            .catch(function (error) {
            _this.keyPromise = null; // let the next call retry
            throw error;
        });
        this.keyPromise = pending;
        return pending;
    };
    EncryptionService.keyPromise = null;
    return EncryptionService;
}());
export { EncryptionService };
